export function saveTokens(
  accessToken: string | undefined,
  refreshToken: string | undefined,
  expiresAt: string | undefined,
  userdiv?: string | undefined,
) {
  localStorage.setItem('hsgaccessToken', accessToken ?? '');
  localStorage.setItem('hsgrefreshToken', refreshToken ?? '');
  localStorage.setItem('hsgexpiresAt', expiresAt ?? '');
  localStorage.setItem('hsguserdiv', userdiv ?? '');
}

export function removeTokens() {
  localStorage.removeItem('hsgaccessToken');
  localStorage.removeItem('hsgrefreshToken');
  localStorage.removeItem('hsgexpiresAt');
  localStorage.removeItem('hsguserdiv');
}

export function getAccessToken() {
  return localStorage.getItem('hsgaccessToken');
}

export function getRefreshToken() {
  return localStorage.getItem('hsgrefreshToken');
}

export function getExpiresAt() {
  return localStorage.getItem('hsgexpiresAt');
}

export function getUserDiv() {
  return localStorage.getItem('hsguserdiv');
}
